<template>
    <button type="button" class="btn btn-primary" @click="copy">{{ label }}</button>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { ref } from 'vue';
import useClipboard from 'vue-clipboard3'

const label = ref();
const props = defineProps<{
    label: string,
    textToCopy: string,
}>();

const { toClipboard } = useClipboard();
const copy = async () => {    
    await toClipboard(props.textToCopy);
    label.value = 'Copied!';
    setTimeout(() => {
        label.value = props.label;
    }, 1500);
}

onMounted(() => {
    label.value = props.label
})
</script>

<style scoped></style>